import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { CustomerType } from 'src/app/models/trofaco/customerDto';
import { DuplicateNameConfirmModalComponent } from './duplicate-name-confirm-modal/duplicate-name-confirm-modal.component';
export class CustomerDetailsComponent {
    constructor(route, router, customerService) {
        this.route = route;
        this.router = router;
        this.customerService = customerService;
        this.customerType = CustomerType;
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.route.data.subscribe(value => {
                this.customer = value.customer;
                this.copyCustomerName = value.customer.name;
                this.countries = value.countries;
                this.hadLogo = !!this.customer.logo;
            });
            this.customersName = yield this.customerService.getCustomersName();
        });
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.customer.name || !this.customer.country)
                return;
            let isDuplicateName = this.customersName.some((element) => {
                const customerName = element.trim().toLocaleLowerCase();
                const newCustomerName = this.customer.name.trim().toLocaleLowerCase();
                return customerName === newCustomerName;
            });
            if (!isDuplicateName || this.copyCustomerName == this.customer.name)
                this.execute();
            else {
                if (this.customer.id)
                    this.confirmDuplicateName.editMode();
                let result = yield this.confirmDuplicateName.showAwait();
                if (result) {
                    this.execute();
                }
            }
        });
    }
    execute() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.customer.id)
                this.customer.id = yield this.customerService.create(this.customer);
            else
                yield this.customerService.update(this.customer);
            if (this.customer.file)
                yield this.customerService.updateLogo(this.customer.file, this.customer.id);
            else if (!!this.customer.file == this.hadLogo)
                yield this.customerService.removeLogo(this.customer.id);
            this.router.navigate(['/admin/customers']);
        });
    }
    removeLogo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.customer.file = null;
            this.hadLogo = false;
        });
    }
}
